'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _module2 = require('../../module');

var _module3 = _interopRequireDefault(_module2);

var _utils = require('../../utils');

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _utils2 = require('../../../core/utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var WinresAccommodationPackages = function () {
    function WinresAccommodationPackages($scope, $filter, localizationService, cancelService, departureService, productService) {
        _classCallCheck(this, WinresAccommodationPackages);

        this.$scope = $scope;
        this.$filter = $filter;
        this.localizationService = localizationService;
        this.cancelService = cancelService;
        this.departureService = departureService;
        this.productService = productService;
        this.packages = [];
        this.hasMore = false;
    }

    _createClass(WinresAccommodationPackages, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.data = this.winresReservationContext.getContext();

            this.$scope.$watch(function () {
                return _this.data.Destination;
            }, function (destination) {
                var destinationCode = destination.DestinationCode;
                if (destinationCode) {
                    _this.initPackages();
                }
            });
        }
    }, {
        key: 'initPackages',
        value: function initPackages() {
            this.packages = [];
            this.loadPackages();
        }
    }, {
        key: 'loadPackages',
        value: function loadPackages() {
            var _this2 = this;

            var urlParams = this.winresReservationContext.getUrlParams();

            var destCode = urlParams.DestinationCode;
            var beginDate = urlParams.StartDate;
            var endDate = urlParams.EndDate;

            if (!beginDate) {
                beginDate = (0, _moment2.default)().format('YYYY-MM-DD');
            }

            if (!endDate) {
                endDate = (0, _moment2.default)().add(1, 'days').format('YYYY-MM-DD');
            }

            var numAdults = urlParams.NumAdult;
            var numChildren = urlParams.NumChildren;

            var language = this.localizationService.getLanguage();

            var searchCriteria = {
                "Language": language,
                "DestCode": destCode,
                "Offset": this.packages ? this.packages.length : 0, // Load more on next load.
                "Limit": "5",
                "Sort": ["DateTime", "Random: 11863"],
                "SearchBeginDate": beginDate,
                "SearchEndDate": endDate,
                "DestClasses1": ["PA"],
                "NumAdults": 1,
                "NumChildren": 0
            };

            var request = this.departureService.searchPackages(searchCriteria, true, language);
            this.loadingPromise = request;

            if (this.pending) {
                this.cancelService.cancel(this.pending);
            }

            this.pending = request;

            request.then(function (response) {
                if (!response) {
                    // Canceled promise.
                    return;
                }

                var packages = response.Results;

                var priceIndex = _this2.priceIndex(numAdults, numChildren);

                // Select first price option for each package.
                _.each(packages, function (pack) {
                    return pack.selectedPrice = pack.OccupancyPrices[priceIndex - 1];
                });

                // Concatenate new packages after existing packages.
                _this2.packages = _.concat(_this2.packages, packages);

                _this2.hasMore = response.Offset + response.Results.length < response.Total;
            });
        }
    }, {
        key: 'priceIndex',
        value: function priceIndex(adults, children) {
            if (adults < 1 || adults > 3) {
                console.error('[WAP] Accommodation packages only support 1-3 adults.');
                return null;
            }
            if (children < 0 || children > 3) {
                console.error('[WAP] Accommodation packages only support 0-3 children.');
                return null;
            }
            return 4 * (adults - 1) + children + 1;
        }
    }, {
        key: 'addToShoppingCart',
        value: function addToShoppingCart(pack) {
            var _this3 = this;

            // Show loading indicator on 'Continue' -button.
            pack.loading = true;

            var urlParams = this.winresReservationContext.getUrlParams();

            var language = this.localizationService.getLanguage();
            var destCode = urlParams.DestinationCode;
            var beginDate = pack.BeginDate;
            var endDate = pack.EndDate;
            var priceIndex = pack.selectedPrice.Index;

            var request = this.productService.getAccommodationPackage(destCode, beginDate, endDate, language);

            request.then(function (response) {
                _this3.picks = _this3.initialPicks(response);

                // The price group to use for the package root product.
                // The linked products' price groups come from the linkings.
                _this3.data.PriceGroup = 'NR';

                var packageIndex = _this3.findNextFreePackageIndex(_this3.data.Products);
                var rootProductLine = _this3.addRootProduct(packageIndex, priceIndex, response.RootProduct);

                _.each(response.ForcedProducts, function (product) {
                    console.log('[WAP - Process forced product]', product.DestinationInfo.DestinationCode, product.DestinationInfo.ProductCode, product.BeginDate, product.EndDate);
                    _this3.addForcedProduct(packageIndex, priceIndex, product);
                });

                _.each(response.GroupForcedProducts, function (group) {
                    var pickedIndex = _this3.picks.groupForced[group.Key];
                    var pickedProduct = group.Value[pickedIndex];
                    _this3.addForcedProduct(packageIndex, priceIndex, pickedProduct);
                });

                // Open shopping cart.        
                window.showShoppingBasket();

                pack.loading = false;
            });
        }
    }, {
        key: 'initialPicks',
        value: function initialPicks(pack) {
            return {
                groupForced: this.initialPicksForGroupForcedProducts(pack.GroupForcedProducts)
            };
        }

        // Create an object where the keys are group IDs and values are initial selections. Initial selection = first value that has capacity.
        // E.g. { '1': 0, '2': 0 }

    }, {
        key: 'initialPicksForGroupForcedProducts',
        value: function initialPicksForGroupForcedProducts(groups) {
            var picks = {};
            _.each(groups, function (group) {
                var id = 0;
                var firstProduct = group.Value[0];
                var groupID = firstProduct.LinkingInfo.GroupID;
                _.each(group.Value, function (value, index) {
                    if (value.Capacity != 0) {
                        id = index;
                        return false;
                    }
                });
                picks[groupID] = id;
            });
            // console.log(picks);
            return picks;
        }
    }, {
        key: 'addRootProduct',
        value: function addRootProduct(packageIndex, priceIndex, product) {
            console.log('[WAP - Add root product]', product);

            var productLine = this.winresReservationContext.findOrCreateProductLineByProduct(product);
            productLine.Amount = 1;
            productLine.Product.Amount = productLine.Amount;
            productLine.PackageRootIndex = packageIndex;

            this.setPriceAmount(productLine, priceIndex, 1);

            this.winresReservationContext.calculateTotalPrice(productLine);

            return productLine;
        }
    }, {
        key: 'findNextFreePackageIndex',
        value: function findNextFreePackageIndex(shoppingCartProductLines) {
            // Package indexes start from 1.
            var indexes = _.map(shoppingCartProductLines, function (line) {
                return line.PackageRootIndex || 0;
            });
            var highestExisting = _.max(indexes) || 0;
            return highestExisting + 1;
        }
    }, {
        key: 'addForcedProduct',
        value: function addForcedProduct(packageIndex, priceIndex, product) {
            console.log('[WAP - Add forced product]', product);
            if (product.DestinationInfo.Accommodation) {
                this.addAccommodationProduct(packageIndex, priceIndex, product);
            } else {
                this.addExtraServiceProduct(packageIndex, priceIndex, product);
            }
        }
    }, {
        key: 'addAccommodationProduct',
        value: function addAccommodationProduct(packageIndex, priceIndex, product) {
            console.log('[WAP - Add accommodation product]', product);

            var productLine = this.winresReservationContext.findOrCreateProductLineByProduct(product);
            productLine.Amount = 1;
            productLine.Product.Amount = productLine.Amount;
            productLine.PackageMemberIndex = packageIndex;
            productLine.PriceGroup = product.LinkingInfo.LinkedPriceGroup;
            productLine.PriceIncludedInPackage = true;
            productLine.UnitPrice = 0;
            productLine.TotalPrice = 0;
            this.assignAllPassengersToAccommodation(productLine, priceIndex);
            // Success not currently checked
        }
    }, {
        key: 'addExtraServiceProduct',
        value: function addExtraServiceProduct(packageIndex, priceIndex, product) {
            console.log('[WAP - Add extra service product]', product);

            var productLine = this.winresReservationContext.findOrCreateProductLineByProduct(product);
            productLine.PriceGroup = product.LinkingInfo.LinkedPriceGroup;
            productLine.PackageMemberIndex = packageIndex;
            productLine.PriceIncludedInPackage = true;
            productLine.UnitPrice = 0;
            productLine.TotalPrice = 0;

            var reservableIndexes = (product.ReservablePrices || []).map(function (x) {
                return x.Index;
            });

            var linkedIndexes = product.LinkingInfo.PriceIndexes || [];
            if (linkedIndexes.length > 0) {
                // All fine.
            } else {
                // Assume all are linked, since we don't have this information for some reason.
                linkedIndexes = reservableIndexes.slice();
                console.warn('[WAP] Service', product.DestinationInfo.DestinationCode, product.DestinationInfo.ProductCode, 'should have at least one linked price index. Defaulting to:', linkedIndexes);
            }

            var numAdultsAndChildren = this.numOfAdultsAndChildrenByIndex(priceIndex);

            var indexes = _.intersection(reservableIndexes, linkedIndexes);

            if (product.LinkingInfo.IsForEachPassenger) {
                var ADULT = 1;
                var CHILD = 2;
                var ad = numAdultsAndChildren.numAdults;
                var ch = numAdultsAndChildren.numChildren;
                if (indexes.length == 2 && indexes[0] == ADULT && indexes[1] == CHILD) {
                    console.log('[WAP] Adding per-passenger service', product.DestinationInfo.DestinationCode, product.DestinationInfo.ProductCode, 'for', ad, 'adults (price index 1) and', ch, 'children (price index 2).');
                    this.setPriceAmount(productLine, ADULT, ad);
                    this.setPriceAmount(productLine, CHILD, ch);
                } else {
                    var index = indexes[0];
                    var amount = ad + ch;
                    console.log('[WAP] Adding per-passenger service', product.DestinationInfo.DestinationCode, product.DestinationInfo.ProductCode, 'with price index', index, 'for', amount, 'passengers');
                    this.setPriceAmount(productLine, index, amount);
                }
            } else {
                var _index = indexes[0];
                console.log('[WAP] Adding per-booking service', product.DestinationInfo.DestinationCode, product.DestinationInfo.ProductCode, 'with price index', _index + '.');
                this.setPriceAmount(productLine, _index, 1);
            }

            this.winresReservationContext.calculateTotalPrice(productLine);
        }
    }, {
        key: 'assignAllPassengersToAccommodation',
        value: function assignAllPassengersToAccommodation(productLine, priceIndex) {
            var info = productLine.Product.DestinationInfo;
            var numAdultsAndChildren = this.numOfAdultsAndChildrenByIndex(priceIndex);

            var count = numAdultsAndChildren.numAdults + numAdultsAndChildren.numChildren;

            if (count > info.Beds + info.ExtraBeds) {
                console.error('[WAP - Assign all passengers accommodation] Not enough beds.', 'Accommodation', info.DestinationCode, '/', info.ProductCode, 'has', info.Beds, 'regular beds', 'and', info.ExtraBeds, 'extra beds.', 'There are', count, 'passengers.');
                throw 'Not enough beds.';
            }
            // Nothing complex needs to be done here. We always reserve only one room.
            // If we reserved more, we'd need to take care that all rooms have adults etc.
            var roomNumber = 1; // The only room
            productLine.PassengerAssignments = [];
            for (var i = 0; i < count; ++i) {
                var assignment = {
                    ProductNumber: roomNumber,
                    PassengerNumber: i
                };
                productLine.PassengerAssignments.push(assignment);
            }
        }
    }, {
        key: 'setPriceAmount',
        value: function setPriceAmount(productLine, index, amount) {
            this.winresReservationContext.setPriceAmount(productLine, index, amount);
        }
    }, {
        key: 'numOfAdultsAndChildrenByIndex',
        value: function numOfAdultsAndChildrenByIndex(index) {
            if (index == null) {
                return null;
            }

            return {
                numAdults: Math.ceil(index / 4), // +1 every 4.
                numChildren: (index - 1) % 4 // 0 1 2 3.
            };
        }
    }, {
        key: 'formatFinnishDate',
        value: function formatFinnishDate(date) {
            return (0, _utils2.formatFinnishDatePretty)(date);
        }
    }, {
        key: 'formatCurrencyEur',
        value: function formatCurrencyEur(price) {
            return this.$filter('currency')(price, '€', 0);
        }
    }]);

    return WinresAccommodationPackages;
}();

WinresAccommodationPackages.$inject = ['$scope', '$filter', 'localizationService', 'cancelService', 'departureService', 'productService'];

function getTemplate($attrs, $sce) {
    return $attrs.templateUrl ? $sce.trustAsResourceUrl((0, _utils.getWebcomponentsUrl)($attrs.templateUrl)) : 'winresAccommodationPackages';
}

getTemplate.$inject = ['$attrs', '$sce'];

_module3.default.run(['$templateCache', function ($templateCache) {
    $templateCache.put('winresAccommodationPackages', require('./winresAccommodationPackages.html'));
}]);

_module3.default.component('winresAccommodationPackages', {
    templateUrl: getTemplate,
    controller: WinresAccommodationPackages,
    require: {
        winresReservationContext: '^^winresReservationContext'
    }
});


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/components/winresAccommodationPackages/winresAccommodationPackages.js
// module id = 514
// module chunks = 2